import { use, useEffect } from 'react';
import { FieldValues } from 'react-hook-form';
import ErrorMessageProviderContext from 'shared/components/error/providers/contexts/error-message-context';

import { BulkUpdateOrganisationUnitScenarioIsActiveCommand } from 'features/residents/models/bulk-update-organisation-unit-scenario-is-active';
import ResidentSettingsProviderContext from 'features/residents/resident-settings/providers/contexts/resident-settings-provider-context';
import { useUpdateBulkScenarioIsActive } from 'features/residents/resident-settings/providers/resident-queries';

type ResidentSettingsBulkEdit = {
  submitChanges: (fieldValues: FieldValues) => Promise<void>;
  updateBulkScenarioIsActiveIsLoading: boolean;
};

const useResidentSettingsBulkEdit = (): ResidentSettingsBulkEdit => {
  const { setErrorMessage } = use(ErrorMessageProviderContext);
  const {
    refetchResidentSettings,
    bulkEditState: { clearResidentSettings },
  } = use(ResidentSettingsProviderContext);

  const {
    mutateAsync: updateBulkScenarioIsActive,
    isPending: updateBulkScenarioIsActiveIsLoading,
    isSuccess: updateBulkScenarioIsActiveIsSuccess,
    isError: updateBulkScenarioIsActiveIsError,
    error: updateBulkScenarioIsActiveError,
  } = useUpdateBulkScenarioIsActive();

  const submitChanges = async (fieldValues: FieldValues): Promise<void> => {
    const command: BulkUpdateOrganisationUnitScenarioIsActiveCommand = {
      organisationUnitIds: fieldValues.organisationUnitIds,
      bulkScenarioActiveStates: fieldValues.bulkScenarioActiveStates,
    };

    await updateBulkScenarioIsActive(command).then(() => refetchResidentSettings());
  };

  useEffect(() => {
    clearResidentSettings();
  }, [updateBulkScenarioIsActiveIsSuccess]);

  useEffect(() => {
    if (!updateBulkScenarioIsActiveError) return;
    setErrorMessage(updateBulkScenarioIsActiveError);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updateBulkScenarioIsActiveIsError]);

  return {
    submitChanges,
    updateBulkScenarioIsActiveIsLoading,
  };
};

export default useResidentSettingsBulkEdit;
